import Link from 'flarum/common/components/Link';
import { ratesOf, tone } from '../util';

/**
 * World commodity prices (scripts/markets/commodities.php, from Alpha Vantage: oil, gas, gold and silver daily,
 * the rest monthly world averages; cocoa from the IMF via FRED). Shared helpers, and the short strip on the Markets page that leads to the
 * full Commodities page (CommoditiesPage.js).
 */
export const GROUPS = [['energy', 'Energy'], ['metals', 'Metals'], ['farm', 'Farm produce']];
export const UNIT = {
  barrel: 'barrel',
  MMBtu: 'MMBtu',
  'troy ounce': 'ounce',
  tonne: 'tonne',
  pound: 'pound'
};
export function commoditiesOf(markets) {
  const items = markets && markets.commodities && markets.commodities.data && markets.commodities.data.items || {};
  return Object.keys(items).map(k => items[k]).filter(c => c && Number(c.price) > 0);
}

/** "$65.20" or, for prices in cents, "19.2¢" */
export function commodityPrice(c, v) {
  const n = Number(v === undefined ? c.price : v);
  if (c.cents) return n.toLocaleString('en-US', {
    maximumFractionDigits: 2
  }) + '¢';
  return '$' + n.toLocaleString('en-US', {
    minimumFractionDigits: n < 100 ? 2 : 0,
    maximumFractionDigits: n < 100 ? 2 : 0
  });
}
export function commodityChange(c) {
  const p = Number(c.prev);
  return p > 0 ? (Number(c.price) - p) / p * 100 : null;
}

/** The naira equivalent at today's dollar rate (not for prices in cents) */
export function commodityNaira(c, markets) {
  const usd = Number(ratesOf(markets).USD) || 0;
  return usd && !c.cents ? '₦' + Math.round(Number(c.price) * usd).toLocaleString('en-US') : null;
}
export function commodityWhen(c) {
  const [y, mo, d] = String(c.date || '').split('-').map(Number);
  if (!y) return '';
  const date = new Date(Date.UTC(y, mo - 1, d || 1));
  return c.interval === 'monthly' ? date.toLocaleDateString('en-GB', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  }) + ' average' : date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC'
  });
}
export function changeView(c) {
  const ch = commodityChange(c);
  if (ch === null) return null;
  return m('span', {
    className: 'VouchaCm-change ' + tone(ch)
  }, (ch > 0 ? '▲ ' : ch < 0 ? '▼ ' : '') + Math.abs(ch).toFixed(2) + '%');
}

/** Markets page: the main prices in one row, leading to the Commodities page */
export default class CommoditiesStrip {
  view(vnode) {
    const all = commoditiesOf(vnode.attrs.markets);
    if (!all.length) return null;
    const pick = ['brent', 'gold', 'natgas', 'cocoa', 'wheat', 'maize'];
    const list = pick.map(k => all.find(c => c.key === k)).filter(Boolean);
    return m('section.VouchaMarkets-section.VouchaCmStrip', [m('.VouchaMk-sectionHead', [m('h2', 'Commodity prices'), m(Link, {
      href: '/commodities',
      className: 'VouchaCmStrip-more'
    }, 'All commodities →')]), m('.VouchaCmStrip-row', list.map(c => m(Link, {
      href: '/commodities#' + c.key,
      className: 'VouchaCmStrip-item',
      key: c.key
    }, [m('span.VouchaCmStrip-name', c.name), m('b', commodityPrice(c)), changeView(c)])))]);
  }
}
flarum.reg.add('voucha-markets', 'forum/components/Commodities', CommoditiesStrip);